import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useToastStore } from '~/stores/toast';
import type { SelectItem } from '#ui/types';

export type LocaleType = 'en' | 'zh-TW';

export const useI18nLocale = () => {
  const router = useRouter();
  const { locale, t, setLocale } = useI18n();
  const toastStore = useToastStore();
  const localePath = useLocalePath();

  const availableLocales = computed<SelectItem[]>(() => {
    return [
      { label: 'English', value: 'en' },
      { label: '中文', value: 'zh-TW' },
    ];
  });

  const currentLocale = computed(() => locale.value);

  async function changeLocale(newLocale: LocaleType, showToastMessage = false) {
    try {
      // 更新 i18n locale（Nuxt i18n 會自動處理 cookie 和 URL）
      await setLocale(newLocale);

      // 使用 Nuxt 的 localePath 來處理 URL 更新
      const currentRoute = router.currentRoute.value;
      await router.push(localePath(currentRoute.path));

      if (showToastMessage) {
        toastStore.success(t('common.messages.success'));
      }
    } catch (error) {
      console.error('Failed to change language:', error);
      if (showToastMessage) {
        toastStore.error(t('common.messages.error'));
      }
    }
  }

  // initLocale 已不再需要，因為 Nuxt i18n 會自動根據 cookie 和 URL 處理語系初始化
  // 保留此函數以維持 API 相容性，但不執行任何操作
  function initLocale() {
    // Nuxt i18n 會自動處理語系初始化（透過 i18n_redirected cookie 和 URL 路徑）
    // 不需要手動從 localStorage 讀取
  }

  return {
    availableLocales,
    currentLocale,
    changeLocale,
    initLocale,
  };
};
